import type { BillState } from '../types/bills.types';

export const initialState: BillState = {
  isValidEditAmount: false,
  manualBills: [],
  manualBillsMid: undefined,
  outstandingBills: {
    outstanding: [],
    pending: [],
  },
};
